/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

window.redirectPost = function(url, data) {
    var form = document.createElement('form');

    // automatically add Laravel csrf Token
    data._token =  document.head.querySelector("[name~=csrf-token][content]").content;

    document.body.appendChild(form);
    form.action = url;
    form.method = 'post';

    for (var name in data) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = data[name];

        form.appendChild(input);
    }

    form.submit();

    return true;
}